var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1B3E6F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M14.458.825 2.417 12.865l2.835 2.836L17.292 3.66zM1 17.12l4.25-1.416-2.833-2.834zM12.334 2.953l2.833 2.834"
})));
export default SvgPencil;